import { Modal } from 'react-aria-components'
import { useSelector } from 'react-redux'
import { pathsByKey } from '../../storyPaths.js'

// Shared full-screen "nothing to do right now" modal: a heading plus a
// preview line from each story path's upcoming beat. Used both by the
// timescale-mode cooldown (GlobalCooldown) and the free-play "nothing
// available in this slot" teaser (FreePlayTeaser).
export default function TeaserModal ({ isOpen, heading }) {
  const scientificDetectiveTeaser = useSelector(pathsByKey.scientificDetective.slice.selectors.selectTeaser)
  const networkersTeaser = useSelector(pathsByKey.networkers.slice.selectors.selectTeaser)
  const factoryTeaser = useSelector(pathsByKey.factory.slice.selectors.selectTeaser)
  const nefariousHeroTeaser = useSelector(pathsByKey.nefariousHero.slice.selectors.selectTeaser)

  return (
    <Modal isOpen={isOpen} isDismissable={false} className='flex z-1000 fixed top-0 h-screen w-screen'>
      <div className='flex-1 backdrop-blur-xs' />
      <div className='flex flex-col flex-11 md:flex-3'>
        <div className='flex-2 backdrop-blur-xs' />
        <div className='flex-1 bg-white p-1'>
          <div className='font-mono h mx2 text-center'>
            {heading}
          </div>
          <div className='text-lg italic text-stone-600 px-4'>
            <div className='text-left'>
              "{scientificDetectiveTeaser}"
            </div>
            <div className='text-right'>
              "{factoryTeaser}"
            </div>
            <div className='text-left'>
              "{networkersTeaser}"
            </div>
            <div className='text-right'>
              "{nefariousHeroTeaser}"
            </div>
          </div>
        </div>
        <div className='flex-2 backdrop-blur-xs' />
      </div>
      <div className='flex-1 backdrop-blur-xs' />
    </Modal>
  )
}
